import {
    formatError,
    getDateError,
    addActivite,
    addCity,
    addCountry,
    addExclusion,
    addProfession,
    saveSuccess,
    getParameter,
    addTypeExclusion,
    addProvince,
    getDictionnaireData,
    updateCountry,
    updateCity,
    updateExclusion,
    updateProfession,
    updateActivite,
    updateDictionaire,
    deleteCountry,
    deleteCity,
    deleteActivite,
    deleteProfession,
    deleteExclusion,
    deleteDictionaire,
    downloadCountryTemplate,
    downloadProvinceTemplate,
    downloadCityTemplate,
    downloadActivityTemplate,
    downloadProfessionTemplate,
    downloadExclusionTypeTemplate,
    downloadExclusionTemplate
} from '../../services/AdministrationService';

// Define constants
const START_LOADER_ACTION = "START_LOADER_ACTION";
const STOP_LOADER_ACTION = "STOP_LOADER";

export function addActiviteAction(data) {
    return (dispatch) => {
        addActivite(data)
        .then((response) => {
            response.data['type'] = 'activite';
            dispatch(confirmedAddAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(addFailedAction(errorMessage));
        });
    };
}

export function addCityAction(data) {
    return (dispatch) => {
        addCity(data)
        .then((response) => {
            response.data['type'] = 'city';
            response.data['countryId'] = data.countryId;
            dispatch(confirmedAddAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(addFailedAction(errorMessage));
        });
    };
}

export function addCountryAction(data) {
    return (dispatch) => {
        addCountry(data)
        .then((response) => {
            response.data['type'] = 'country';
            dispatch(confirmedAddAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(addFailedAction(errorMessage));
        });
    };
}

export function addExclusionAction(data) {
    return (dispatch) => {
        addExclusion(data)
        .then((response) => {
            response.data['type'] = 'exclusion';
            dispatch(confirmedAddAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(addFailedAction(errorMessage));
        });
    };
}

export function addProfessionAction(data) {
    return (dispatch) => {
        addProfession(data)
        .then((response) => {
            response.data['type'] = 'profession';
            response.data['activityAreaId'] = data.activityAreaId;
            dispatch(confirmedAddAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(getFailedAction(errorMessage));
        });
    };
}

export function addTypeExclusionAction(data) {
    return (dispatch) => {
        addTypeExclusion(data)
        .then((response) => {
            response.data['type'] = 'type-exclusion';
            dispatch(confirmedAddAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(getFailedAction(errorMessage));
        });
    };
}

export function addProvinceAction(data) {
    return (dispatch) => {
        addProvince(data)
        .then((response) => {
            response.data['type'] = 'province';
            dispatch(confirmedAddAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(getFailedAction(errorMessage));
        });
    };
}

export function getParameterAction() {
    return (dispatch) => {
        getParameter()
        .then((response) => {
            dispatch(confirmedGetAction(response.data));
        })
        .catch((error) => {
            const errorMessage = getDateError(error);
            dispatch(getFailedAction(errorMessage));
        });
    };
}

export function getDictionnaireDataAction(type) {
    return (dispatch) => {
        getDictionnaireData(type)
        .then((response) => {
            dispatch(confirmedGetDitionAction(response.data, type));
        })
        .catch((error) => {
            const errorMessage = getDateError(error);
            dispatch(getFailedAction(errorMessage));
        });
    };
}

export function updateCountryAction(id, data) {
    return (dispatch) => {
        updateCountry(id, data)
        .then((response) => {
            response.data['type'] = 'country';
            response.data['id'] = id;
            dispatch(confirmedUpdateAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(updateFailedAction(errorMessage));
        });
    };
}

export function updateCityAction(id, data) {
    return (dispatch) => {
        updateCity(id, data)
        .then((response) => {
            response.data['type'] = 'city';
            response.data['id'] = id;
            response.data['countryId'] = data.countryId;
            dispatch(confirmedUpdateAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(updateFailedAction(errorMessage));
        });
    };
}

export function updateExclusionAction(id, data) {
    return (dispatch) => {
        updateExclusion(id, data)
        .then((response) => {
            response.data['type'] = 'exclusion';
            response.data['id'] = id;
            response.data['code'] = data.code;
            response.data['nameFr'] = data.nameFr;
            response.data['nameEn'] = data.nameEn;
            dispatch(confirmedUpdateAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(updateFailedAction(errorMessage));
        });
    };
}

export function updateProfessionAction(id, data) {
    return (dispatch) => {
        updateProfession(id, data)
        .then((response) => {
            response.data['type'] = 'profession';
            response.data['id'] = id;
            response.data['activityAreaId'] = data.activityAreaId;
            dispatch(confirmedUpdateAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(updateFailedAction(errorMessage));
        });
    };
}

export function updateActiviteAction(id, data) {
    return (dispatch) => {
        updateActivite(id, data)
        .then((response) => {
            response.data['type'] = 'activite';
            response.data['id'] = id;
            dispatch(confirmedUpdateAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(updateFailedAction(errorMessage));
        });
    };
}

export function updateDictionaireAction(id, data, type) {
    return (dispatch) => {
        updateDictionaire(id, data)
        .then((response) => {
            response.data['type'] = type;
            response.data['id'] = id;
            dispatch(confirmedUpdateAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(updateFailedAction(errorMessage));
        });
    };
}

export function deleteCountryAction(id) {
    return (dispatch) => {
        deleteCountry(id)
        .then((response) => {
            response.data['type'] = 'country';
            response.data['id'] = id;
            dispatch(confirmedDeleteAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(deleteFailedAction(errorMessage));
        });
    };
}

export function deleteCityAction(id, countryId) {
    return (dispatch) => {
        deleteCity(id)
        .then((response) => {
            response.data['type'] = 'city';
            response.data['countryId'] = countryId;
            response.data['id'] = id;
            dispatch(confirmedDeleteAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(deleteFailedAction(errorMessage));
        });
    };
}

export function deleteActiviteAction(id) {
    return (dispatch) => {
        deleteActivite(id)
        .then((response) => {
            let data = {};
            data['type'] = 'activite';
            data['id'] = id;
            dispatch(confirmedDeleteAction(data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(deleteFailedAction(errorMessage));
        });
    };
}

export function deleteProfessionAction(id, activityAreaId) {
    return (dispatch) => {
        deleteProfession(id)
        .then((response) => {
            response.data['type'] = 'profession';
            response.data['activityAreaId'] = activityAreaId;
            response.data['id'] = id;
            dispatch(confirmedDeleteAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(deleteFailedAction(errorMessage));
        });
    };
}

export function deleteExclusionAction(id) {
    return (dispatch) => {
        deleteExclusion(id)
        .then((response) => {
            response.data['type'] = 'exclusion';
            response.data['id'] = id;
            dispatch(confirmedDeleteAction(response.data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(deleteFailedAction(errorMessage));
        });
    };
}

export function deleteDictionaireAction(id, type) {
    return (dispatch) => {
        deleteDictionaire(id)
        .then((response) => {
            let data = {};
            data['type'] = type;
            data['id'] = id;
            dispatch(confirmedDeleteAction(data));
            saveSuccess()
        })
        .catch((error) => {
            const errorMessage = formatError(error);
            dispatch(deleteFailedAction(errorMessage));
        });
    };
}

// Template download actions with proper error handling
export const downloadCountryTemplateAction = () => {
    return (dispatch) => {
        dispatch(downloadTemplateRequestAction());
        dispatch(startLoader());
        
        downloadCountryTemplate()
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'countries_template.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                // Show success message if available
                if (typeof successToastr !== 'undefined') {
                    successToastr('Template téléchargé avec succès');
                }
                dispatch(downloadTemplateSuccessAction());
                dispatch({ type: STOP_LOADER_ACTION });
            })
            .catch((error) => {
                console.error('Download error:', error);
                // Show error message if available
                if (typeof errorToastr !== 'undefined') {
                    errorToastr('Erreur lors du téléchargement du template');
                }
                dispatch(downloadTemplateFailedAction(error.response?.data?.message || 'Erreur lors du téléchargement'));
                dispatch({ type: STOP_LOADER_ACTION });
            });
    };
};

export const downloadProvinceTemplateAction = () => {
    return (dispatch) => {
        dispatch(downloadTemplateRequestAction());
        dispatch(startLoader());
        
        downloadProvinceTemplate()
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'provinces_template.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                if (typeof successToastr !== 'undefined') {
                    successToastr('Template téléchargé avec succès');
                }
                dispatch(downloadTemplateSuccessAction());
                dispatch({ type: STOP_LOADER_ACTION });
            })
            .catch((error) => {
                console.error('Download error:', error);
                if (typeof errorToastr !== 'undefined') {
                    errorToastr('Erreur lors du téléchargement du template');
                }
                dispatch(downloadTemplateFailedAction(error.response?.data?.message || 'Erreur lors du téléchargement'));
                dispatch({ type: STOP_LOADER_ACTION });
            });
    };
};

export const downloadCityTemplateAction = () => {
    return (dispatch) => {
        dispatch(downloadTemplateRequestAction());
        dispatch(startLoader());
        
        downloadCityTemplate()
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'cities_template.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                if (typeof successToastr !== 'undefined') {
                    successToastr('Template téléchargé avec succès');
                }
                dispatch(downloadTemplateSuccessAction());
                dispatch({ type: STOP_LOADER_ACTION });
            })
            .catch((error) => {
                console.error('Download error:', error);
                if (typeof errorToastr !== 'undefined') {
                    errorToastr('Erreur lors du téléchargement du template');
                }
                dispatch(downloadTemplateFailedAction(error.response?.data?.message || 'Erreur lors du téléchargement'));
                dispatch({ type: STOP_LOADER_ACTION });
            });
    };
};

export const downloadActivityTemplateAction = () => {
    return (dispatch) => {
        dispatch(downloadTemplateRequestAction());
        dispatch(startLoader());
        
        downloadActivityTemplate()
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'activities_template.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                if (typeof successToastr !== 'undefined') {
                    successToastr('Template téléchargé avec succès');
                }
                dispatch(downloadTemplateSuccessAction());
                dispatch({ type: STOP_LOADER_ACTION });
            })
            .catch((error) => {
                console.error('Download error:', error);
                if (typeof errorToastr !== 'undefined') {
                    errorToastr('Erreur lors du téléchargement du template');
                }
                dispatch(downloadTemplateFailedAction(error.response?.data?.message || 'Erreur lors du téléchargement'));
                dispatch({ type: STOP_LOADER_ACTION });
            });
    };
};

export const downloadProfessionTemplateAction = () => {
    return (dispatch) => {
        dispatch(downloadTemplateRequestAction());
        dispatch(startLoader());
        
        downloadProfessionTemplate()
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'professions_template.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                if (typeof successToastr !== 'undefined') {
                    successToastr('Template téléchargé avec succès');
                }
                dispatch(downloadTemplateSuccessAction());
                dispatch({ type: STOP_LOADER_ACTION });
            })
            .catch((error) => {
                console.error('Download error:', error);
                if (typeof errorToastr !== 'undefined') {
                    errorToastr('Erreur lors du téléchargement du template');
                }
                dispatch(downloadTemplateFailedAction(error.response?.data?.message || 'Erreur lors du téléchargement'));
                dispatch({ type: STOP_LOADER_ACTION });
            });
    };
};

export const downloadExclusionTypeTemplateAction = () => {
    return (dispatch) => {
        dispatch(downloadTemplateRequestAction());
        dispatch(startLoader());
        
        downloadExclusionTypeTemplate()
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'exclusion_types_template.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                if (typeof successToastr !== 'undefined') {
                    successToastr('Template téléchargé avec succès');
                }
                dispatch(downloadTemplateSuccessAction());
                dispatch({ type: STOP_LOADER_ACTION });
            })
            .catch((error) => {
                console.error('Download error:', error);
                if (typeof errorToastr !== 'undefined') {
                    errorToastr('Erreur lors du téléchargement du template');
                }
                dispatch(downloadTemplateFailedAction(error.response?.data?.message || 'Erreur lors du téléchargement'));
                dispatch({ type: STOP_LOADER_ACTION });
            });
    };
};

export const downloadExclusionTemplateAction = () => {
    return (dispatch) => {
        dispatch(downloadTemplateRequestAction());
        dispatch(startLoader());
        
        downloadExclusionTemplate()
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'exclusions_template.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                if (typeof successToastr !== 'undefined') {
                    successToastr('Template téléchargé avec succès');
                }
                dispatch(downloadTemplateSuccessAction());
                dispatch({ type: STOP_LOADER_ACTION });
            })
            .catch((error) => {
                console.error('Download error:', error);
                if (typeof errorToastr !== 'undefined') {
                    errorToastr('Erreur lors du téléchargement du template');
                }
                dispatch(downloadTemplateFailedAction(error.response?.data?.message || 'Erreur lors du téléchargement'));
                dispatch({ type: STOP_LOADER_ACTION });
            });
    };
};

// Helper actions
export const downloadTemplateRequestAction = () => {
    return {
        type: "DOWNLOAD_TEMPLATE_REQUEST"
    };
};

export const downloadTemplateSuccessAction = () => {
    return {
        type: "DOWNLOAD_TEMPLATE_SUCCESS"
    };
};

export const downloadTemplateFailedAction = (error) => {
    return {
        type: "DOWNLOAD_TEMPLATE_FAILED",
        payload: error
    };
};

export function confirmedDeleteAction(data) {
    return {
        type: "DELETE_CONFIRMED_ACTION",
        payload: data,
    }
}

export function deleteFailedAction(data) {
    return {
        type: "DELETE_FAILED_ACTION",
        payload: data,
    };
}

export function confirmedUpdateAction(data) {
    return {
        type: "UPDATE_CONFIRMED_ACTION",
        payload: data,
    }
}

export function updateFailedAction(data) {
    return {
        type: "UPDATE_FAILED_ACTION",
        payload: data,
    };
}

export function addFailedAction(data) {
    return {
        type: "ADD_FAILED_ACTION",
        payload: data,
    };
}

export function getFailedAction(data) {
    return {
        type: "GET_FAILED_ACTION",
        payload: data,
    };
}

export function confirmedAddAction(data) {
    return {
        type: "ADD_CONFIRMED_ACTION",
        payload: data,
    };
}

export function confirmedGetAction(data) {
    return {
        type: "GET_CONFIRMED_ACTION",
        payload: data,
    };
}

export function loadingToggleAction() {
    return {
        type: "LOADING_TOGGLE_ACTION"
    };
}

export function startLoader() {
    return {
        type: START_LOADER_ACTION
    };
}

export function confirmedGetDitionAction(data, type) {
    if (type === 'province') {
        return {
            type: "GET_DICT_PROV_ACTION",
            payload: data,
        };
    } else {
        return {
            type: "GET_DICT_TYPE_EXCL_ACTION",
            payload: data,
        };
    }
}